import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginSegmentEvent } from "../../libs/segmentEventHandler";
import { getUser, setUser, setUserToken } from "../../libs/user";
import {
  validateEmail as checkEmail,
  userSignup as signup,
  userLogin as login,
  forgotPassword,
  validateOTP,
  verifyOtpService,
  resetPassword,
  resendOtpService,
  mobileLoginService,
  loginVerifyOtpService,
  updateProfileService,
  updatePhoneService,
  updatedVerifyOtp,
  updateResendOtpService,
  getProfileService,
  reauthenticateService,
  resgisterPassKeyService,
  completeResgisterPassKeyService,
  initiatePassKeyloginService,
  completeloginWithPassKeyService,
  getRegistedredPassKeyService,
} from "../../services/auth";
import { startLoader, stopLoader } from "./appSlice";
import { getRecaptcha as generateRecaptcha } from "../../libs/utils";
import {
  decodeToStr,
  encodeStr,
  encodeStrToByteArray,
} from "../../utils/helper";
import { postMparticleEvent, sendEvent } from "../../libs/events";

export const validateEmail = createAsyncThunk(
  "auth/validateEmail",
  async (email, { rejectWithValue }) => {
    try {
      const response = await checkEmail(email);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userSignup = createAsyncThunk(
  "auth/userSignup",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const {
        mobile_number,
        refCode,
        reCaptcha,
        deviceId,
        firstName,
        lastName,
        email,
        password,
        isEmailSignup = false,
        everflowTxnId,
        utm_content,
        apiVersion,
        signupSource,
      } = obj;
      let body = {};
      if (isEmailSignup) {
        body = {
          first_name: firstName || "",
          last_name: lastName || "",
          email: email,
          password: password,
          ref_code: refCode || "",
        };
      } else {
        body = {
          mobile_number: mobile_number || "",
          ref_code: refCode || "",
          everflowTxnId,
          utm_content,
          apiVersion,
          signupSource,
        };
      }
      const channel = (() => {
        try {
          return window.sessionStorage.getItem("channel") || "";
        } catch (e) {
          return "";
        }
      })();
      const shouldUseRecaptcha = channel !== "TOI";
      const newCaptcha = shouldUseRecaptcha
        ? reCaptcha
          ? reCaptcha
          : await getCaptch(reCaptcha, "signup")
        : null;
      const response = await signup(body, newCaptcha, deviceId, isEmailSignup);
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const {
        phone,
        otp,
        message_id,
        fingerprint,
        updateUserEmail = false,
        email,
        utm_source,
      } = obj;
      const verifyOtpResponse = await verifyOtpService(
        phone,
        otp,
        message_id,
        fingerprint,
        utm_source
      );

      const { id, customer_id } = verifyOtpResponse?.user || {};

      loginSegmentEvent(customer_id, {
        email,
        Phone_Number: phone,
        customerId: customer_id,
      });
      if (id) {
        try {
          if (typeof window.clarity === "function") {
            window.clarity("identify", String(id));
          } else {
            sendEvent("Clarity_identify_failed", {
              id,
              reason: "clarity_not_initialized",
            });
          }
        } catch (error) {
          sendEvent("Clarity_identify_failed", {
            id,
            reason: "clarity_identify_error",
          });
        }
      }
      if (updateUserEmail) {
        await updateProfileService("", "", email, verifyOtpResponse.token);
      }
      if (
        typeof window?.webkit?.messageHandlers?.tilAppWebBridge != "undefined"
      ) {
        window.webkit.messageHandlers.tilAppWebBridge.postMessage({
          requestReason: "aboundLogin",
          type: "abound",
          value: JSON.stringify({ token: verifyOtpResponse.token }),
        });
      }
      if (typeof window.tilAppWebBridge !== "undefined") {
        window.tilAppWebBridge.postMessage(
          JSON.stringify({
            requestReason: "aboundLogin",
            type: "abound",
            value: JSON.stringify({ token: verifyOtpResponse.token }),
          })
        );
      }
      // Ensure loader is actually cleared before the thunk resolves.
      // This avoids "stuck loader" when navigating immediately after OTP verify.
      await dispatch(stopLoader());
      return verifyOtpResponse;
    } catch (error) {
      await dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { first_name, last_name, email, token } = obj;
      const response = await updateProfileService(
        first_name,
        last_name,
        email,
        token
      );
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchProfileData = createAsyncThunk(
  "auth/fetchProfileData",
  async (obj, { rejectWithValue }) => {
    try {
      const { token } = obj;
      const response = await getProfileService(token);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const loginVerifyOtp = createAsyncThunk(
  "auth/loginVerifyOtp",
  async (obj, { rejectWithValue }) => {
    try {
      const { phone, otp, message_id } = obj;
      const response = await loginVerifyOtpService(phone, otp, message_id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updatedPhone = createAsyncThunk(
  "auth/updatePhone",
  async (obj, { rejectWithValue }) => {
    try {
      const { mobile_number, token } = obj;
      const response = await updatePhoneService(mobile_number, token);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const verifyUpdatedOtp = createAsyncThunk(
  "auth/updateVerifyOtp",
  async (obj, { rejectWithValue }) => {
    try {
      const { mobile_number, otp, message_id, verify_otp_type, token } = obj;
      const response = await updatedVerifyOtp(
        mobile_number,
        otp,
        message_id,
        verify_otp_type,
        token
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resendOtp = createAsyncThunk(
  "auth/resendOtp",
  async (obj, { rejectWithValue }) => {
    try {
      const { phone, message_id } = obj;
      const response = await resendOtpService(phone, message_id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateResendOtp = createAsyncThunk(
  "auth/updateResendOtp",
  async (obj, { rejectWithValue }) => {
    try {
      const { mobile_number, message_id, token } = obj;
      const response = await updateResendOtpService(
        mobile_number,
        message_id,
        token
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { email, password, reCaptcha, deviceId } = obj;
      const channel = (() => {
        try {
          return window.sessionStorage.getItem("channel") || "";
        } catch (e) {
          return "";
        }
      })();
      const shouldUseRecaptcha = channel !== "TOI";
      const newCaptcha = shouldUseRecaptcha
        ? reCaptcha
          ? reCaptcha
          : await getCaptch(reCaptcha, "login")
        : null;
      const response = await login(email, password, newCaptcha, deviceId);
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

const getCaptch = async (reCaptcha, action) => {
  if (reCaptcha) {
    return reCaptcha;
  }
  const newCaptcha = await generateRecaptcha(action);
  return newCaptcha;
};

export const mobileLogin = createAsyncThunk(
  "auth/mobileLogin",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { mobile_number, reCaptcha, deviceId } = obj;
      const channel = (() => {
        try {
          return window.sessionStorage.getItem("channel") || "";
        } catch (e) {
          return "";
        }
      })();
      const shouldUseRecaptcha = channel !== "TOI";
      const newCaptcha = shouldUseRecaptcha
        ? reCaptcha
          ? reCaptcha
          : await getCaptch(reCaptcha, "login")
        : null;
      const response = await mobileLoginService(
        mobile_number,
        newCaptcha,
        deviceId
      );
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAuth = createAsyncThunk(
  "auth/getAuth",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await getUser();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const userForgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (obj, { rejectWithValue }) => {
    try {
      const { email } = obj;
      const response = await forgotPassword(email);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userOTPValidate = createAsyncThunk(
  "auth/userOTPValidate",
  async (obj, { rejectWithValue }) => {
    try {
      const { email, otp } = obj;
      const response = await validateOTP(email, otp);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userResetPassword = createAsyncThunk(
  "auth/userResetPassword",
  async (obj, { rejectWithValue }) => {
    try {
      const { email, otp, newPassword, confirmPassword } = obj;
      const response = await resetPassword(
        email,
        otp,
        newPassword,
        confirmPassword
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userReauthenticate = createAsyncThunk(
  "auth/userReauthenticate",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { login_type, token, mobile_number } = obj;
      const response = await reauthenticateService(
        login_type,
        token,
        mobile_number
      );
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

const clearPreviousErrors = createAsyncThunk(
  "auth/clearPreviousErrors",
  async () => {
    return { error: "" };
  }
);

export const registerPassKey = createAsyncThunk(
  "auth/registerPassKey",
  async ({ navigate, nextPath }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      dispatch(clearPreviousErrors());
      const registerPassKeyRes = await resgisterPassKeyService();
      const { success, publicKeyCredentialCreationOptions, requestId } =
        registerPassKeyRes;
      if (success && publicKeyCredentialCreationOptions) {
        try {
          const {
            challenge,
            user,
            excludeCredentials,
            authenticatorSelection: {
              requireResidentKey,
              residentKey,
              userVerification,
            },
          } = publicKeyCredentialCreationOptions;
          const encodeChallenge = encodeStrToByteArray(challenge);
          const encodedId = encodeStr(user.id);
          const publicKey = {
            ...publicKeyCredentialCreationOptions,
            challenge: encodeChallenge,
            user: {
              ...user,
              id: encodedId,
            },
            excludeCredentials: excludeCredentials.map((ec) => ({
              ...ec,
              id: encodeStrToByteArray(ec.id),
              transports: ["internal"],
            })),
            extensions: {
              credProps: true,
            },
            authenticatorSelection: {
              requireResidentKey,
              residentKey,
              userVerification,
            },
          };
          const credentials = await navigator.credentials.create({
            publicKey,
            authenticatorSelection: {
              requireResidentKey: true,
              residentKey: "required",
            },
          });
          if (credentials) {
            const {
              rawId,
              response: { attestationObject, clientDataJSON },
              id,
              type,
            } = credentials;
            const rawIdStr = decodeToStr(rawId);
            const attestationObjectStr = decodeToStr(attestationObject);
            const clientDataJSONStr = decodeToStr(clientDataJSON);
            const completeResgisterPassKeyData = {
              requestId,
              credential: {
                id,
                rawId: rawIdStr,
                type,
                response: {
                  clientDataJSON: clientDataJSONStr,
                  attestationObject: attestationObjectStr,
                },
                clientExtensionResults: {},
              },
            };
            const completeRegisterPassKeyRes =
              await completeResgisterPassKeyService(
                completeResgisterPassKeyData
              );
            if (completeRegisterPassKeyRes.success) {
              postMparticleEvent({
                eventName: "passkey_created_successfully",
                eventType: ["EVENT"],
                attributes: {},
              });
              dispatch(fetchRegisteredPassKeys());
              return completeRegisterPassKeyRes;
            }
          }
        } catch (e) {
          let message = e.message;
          dispatch(stopLoader());
          if (e.name === "OperationError") {
            message = "Please refresh the page and try again!";
          }
          if (e.name === "NotAllowedError") {
            postMparticleEvent({
              eventName: "create_passkey_cancelled",
              eventType: ["EVENT"],
              attributes: {},
            });
            message = "The operation either timed out or was not allowed.";
          }
          return rejectWithValue({
            registrationComplete: false,
            error: message,
          });
        }
      }
      dispatch(stopLoader());
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue({
        registrationComplete: false,
        error: error.response.data?.error?.message,
      });
    }
  }
);

export const initiatePasskeylogin = createAsyncThunk(
  "auth/initiatePasskeylogin",
  async ({ navigate, deviceId }, { rejectWithValue, dispatch }) => {
    try {
      const abortController = new AbortController();
      dispatch(startLoader());
      const initiatePasskeyloginRes = await initiatePassKeyloginService();
      const {
        success,
        assertionRequest: { publicKeyCredentialRequestOptions },
        requestId,
      } = initiatePasskeyloginRes;
      if (success && publicKeyCredentialRequestOptions) {
        dispatch(stopLoader());
        const { challenge, rpId } = publicKeyCredentialRequestOptions;
        const encodeChallenge = encodeStrToByteArray(challenge);
        try {
          const credential = await navigator.credentials.get({
            publicKey: {
              // ...publicKeyCredentialRequestOptions,
              challenge: encodeChallenge,
              rpId,
              allowCredentials: [],
              // extensions: {},
              userVerification: "preferred",
            },
            signal: abortController.signal,
            mediation: "conditional",
          });
          if (credential) {
            const {
              rawId,
              response: {
                authenticatorData,
                clientDataJSON,
                signature,
                userHandle,
              },
              id,
              type,
            } = credential;
            const rawIdStr = decodeToStr(rawId);
            const authenticatorDataStr = decodeToStr(authenticatorData);
            const signatureStr = decodeToStr(signature);
            const userHandleStr = String.fromCharCode.apply(
              null,
              new Uint8Array(userHandle)
            );
            // const userHandleStr = atob(decodeToStr(userHandle));
            const clientDataJSONStr = decodeToStr(clientDataJSON);
            const completeloginWithPassKeyData = {
              requestId,
              credential: {
                id,
                rawId: rawIdStr,
                type,
                response: {
                  clientDataJSON: clientDataJSONStr,
                  authenticatorData: authenticatorDataStr,
                  signature: signatureStr,
                  userHandle: userHandleStr,
                },
                clientExtensionResults: {},
              },
            };
            const completeloginWithPassKeyRes =
              await completeloginWithPassKeyService(
                completeloginWithPassKeyData,
                deviceId
              );
            if (completeloginWithPassKeyRes.success) {
              const {
                token,
                user: { email_updated },
              } = completeloginWithPassKeyRes || {};
              setUserToken(token);
              await setUser(completeloginWithPassKeyRes);
              if (!email_updated) {
                navigate("/signup", { replace: true });
              } else {
                navigate("/accounts", { replace: true });
              }
              return completeloginWithPassKeyRes;
              // setUser(completeloginWithPassKeyRes).then((data) => {
              //   if (!email_updated) {
              //     navigate("/signup", { replace: true });
              //   } else {
              //     navigate("/accounts", { replace: true });
              //   }
              //   return completeloginWithPassKeyRes;
              // });
            }
          }
          dispatch(stopLoader());
        } catch (e) {
          let message = e.message;
          dispatch(stopLoader());
          if (e.name === "OperationError") {
            message = "Please refresh the page and try again!";
          }
          if (e.name !== "SecurityError" && e.name !== "OperationError") {
            // dispatch(initiatePasskeylogin({ navigate }));
          }
          return rejectWithValue({ error: message });
        }
      }
      dispatch(stopLoader());
    } catch (error) {
      dispatch(stopLoader());
      // dispatch(initiatePasskeylogin({ navigate }));
      return rejectWithValue({ error: error.response.data?.error?.message });
    }
  }
);

export const fetchRegisteredPassKeys = createAsyncThunk(
  "auth/fetchRegisteredPassKeys",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const registeredPasskeysRes = await getRegistedredPassKeyService();
      const { success, user_passkey_details } = registeredPasskeysRes;
      if (success) {
        dispatch(stopLoader());
        try {
          dispatch(stopLoader());
          return user_passkey_details;
        } catch (e) {
          dispatch(stopLoader());
          return rejectWithValue({ error: false });
        }
      }
      dispatch(stopLoader());
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  validateEmail: {
    data: null,
    error: null,
    status: null,
  },
  userSignup: {
    data: null,
    error: null,
    status: null,
  },
  userLogin: {
    data: null,
    error: null,
    status: null,
  },
  user: {
    data: null,
    error: null,
    status: null,
  },
  forgotPasword: {
    data: null,
    error: null,
    status: null,
  },
  otpValidate: {
    data: null,
    error: null,
    status: null,
  },
  resetPassword: {
    data: null,
    error: null,
    status: null,
  },
  verifyOtpService: {
    data: null,
    error: null,
    status: null,
  },
  resendOtp: {
    data: null,
    error: null,
    status: null,
  },
  mobileLoginService: {
    data: null,
    error: null,
    status: null,
  },
  loginVerifyOtpService: {
    data: null,
    error: null,
    status: null,
  },
  updateProfileService: {
    data: null,
    error: null,
    status: null,
  },
  updatePhoneService: {
    data: null,
    error: null,
    status: null,
  },
  updatedVerifyOtp: {
    data: null,
    error: null,
    status: null,
  },
  getProfileService: {
    data: null,
    error: null,
    status: null,
  },
  reuathenticateService: {
    data: null,
    error: null,
    status: null,
  },
  registerPassKey: {},
  registeredPassKeys: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    otpValidateReset: (state) => {
      state.otpValidate = {
        ...state.otpValidate,
        status: null,
        error: null,
        data: null,
      };
    },
    resetPasswordReset: (state) => {
      state.resetPassword = {
        ...state.resetPassword,
        status: null,
        error: null,
        data: null,
      };
    },
    resetMigratedUser: (state) => {
      const migratedUser = {
        ...(state.user?.data || {}),
        user: {
          ...(state.user?.data?.user || {}),
          user_migrated: true,
        },
      };
      state.getProfileService = {
        ...state.getProfileService,
        status: null,
        error: null,
        data: {
          ...state.getProfileService.data,
          user: { ...state.getProfileService?.data?.user, user_migrated: true },
        },
      };
      state.user = {
        ...state.user,
        data: migratedUser,
      };
    },
    resetVerifyOtp: (state) => {
      state.verifyOtpService = {
        ...state.verifyOtpService,
        status: null,
        error: null,
        data: null,
      };
    },
    resetResendOtp: (state) => {
      state.resendOtp = {
        ...state.resendOtp,
        status: null,
        error: null,
        data: null,
      };
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setUserPhone: (state, action) => {
      state.toiMobileInput = action.payload;
    },
    reauthenticateUser: (state) => {
      state.reauthenticateUserData = {
        ...state.reauthenticateUserData,
        status: null,
        error: null,
        data: null,
      };
    },
    resetUserSignup: (state) => {
      state.userSignup = {
        ...state.userSignup,
        status: null,
        error: null,
        data: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateEmail.pending, (state, action) => {
        state.validateEmail = { ...state.validateEmail, status: "loading" };
      })
      .addCase(validateEmail.fulfilled, (state, action) => {
        state.validateEmail = {
          ...state.validateEmail,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(validateEmail.rejected, (state, action) => {
        state.validateEmail = {
          ...state.validateEmail,
          status: "failed",
          error: action.payload.error,
          data: null,
        };
      })
      .addCase(userSignup.pending, (state, action) => {
        state.userSignup = { ...state.userSignup, status: "loading" };
      })
      .addCase(userSignup.fulfilled, (state, action) => {
        state.userSignup = {
          ...state.userSignup,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userSignup.rejected, (state, action) => {
        state.userSignup = {
          ...state.userSignup,
          status: "failed",
          error: action.payload.error,
          data: null,
        };
      })
      .addCase(updateProfile.pending, (state, action) => {
        state.updateProfileService = {
          ...state.updateProfileService,
          status: "loading",
        };
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.updateProfileService = {
          ...state.updateProfileService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
        state.user = {
          ...state.user,
          data: { ...action.payload },
        };
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.updateProfileService = {
          ...state.updateProfileService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(userLogin.pending, (state, action) => {
        state.userLogin = { ...state.userLogin, status: "loading" };
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.userLogin = {
          ...state.userLogin,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.userLogin = {
          ...state.userLogin,
          status: "failed",
          error: action.payload.error,
          data: null,
        };
      })

      .addCase(fetchProfileData.pending, (state, action) => {
        state.getProfileService = {
          ...state.getProfileService,
          status: "loading",
        };
      })
      .addCase(fetchProfileData.fulfilled, (state, action) => {
        state.getProfileService = {
          ...state.getProfileService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchProfileData.rejected, (state, action) => {
        state.getProfileService = {
          ...state.getProfileService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })

      .addCase(mobileLogin.pending, (state, action) => {
        state.mobileLoginService = {
          ...state.mobileLoginService,
          status: "loading",
        };
      })
      .addCase(mobileLogin.fulfilled, (state, action) => {
        state.mobileLoginService = {
          ...state.mobileLoginService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(mobileLogin.rejected, (state, action) => {
        state.mobileLoginService = {
          ...state.mobileLoginService,
          status: "failed",
          error: action.payload.error,
          data: null,
        };
      })

      .addCase(getAuth.pending, (state, action) => {
        state.user = { ...state.user, status: "loading" };
      })
      .addCase(getAuth.fulfilled, (state, action) => {
        state.user = {
          ...state.user,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
        state.user = {
          data: { ...action.payload },
        };
        setUserToken(state.user.token);
      })
      .addCase(getAuth.rejected, (state, action) => {
        state.user = {
          ...state.user,
          status: "failed",
          error: action.payload,
          data: null,
        };
        // removeUserToken();
      })

      .addCase(userForgotPassword.pending, (state, action) => {
        state.forgotPasword = { ...state.forgotPasword, status: "loading" };
      })
      .addCase(userForgotPassword.fulfilled, (state, action) => {
        state.forgotPasword = {
          ...state.forgotPasword,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userForgotPassword.rejected, (state, action) => {
        state.forgotPasword = {
          ...state.forgotPasword,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(userOTPValidate.pending, (state, action) => {
        state.otpValidate = { ...state.otpValidate, status: "loading" };
      })
      .addCase(userOTPValidate.fulfilled, (state, action) => {
        state.otpValidate = {
          ...state.otpValidate,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userOTPValidate.rejected, (state, action) => {
        state.otpValidate = {
          ...state.otpValidate,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(loginVerifyOtp.pending, (state, action) => {
        state.loginVerifyOtpService = {
          ...state.loginVerifyOtpService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(loginVerifyOtp.fulfilled, (state, action) => {
        state.loginVerifyOtpService = {
          ...state.loginVerifyOtpService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(loginVerifyOtp.rejected, (state, action) => {
        state.loginVerifyOtpService = {
          ...state.loginVerifyOtpService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })

      .addCase(updatedPhone.pending, (state, action) => {
        state.updatePhoneService = {
          ...state.updatePhoneService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(updatedPhone.fulfilled, (state, action) => {
        state.updatePhoneService = {
          ...state.updatePhoneService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(updatedPhone.rejected, (state, action) => {
        state.updatePhoneService = {
          ...state.updatePhoneService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(verifyUpdatedOtp.pending, (state, action) => {
        state.updatedVerifyOtp = {
          ...state.updatedVerifyOtp,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(verifyUpdatedOtp.fulfilled, (state, action) => {
        state.updatedVerifyOtp = {
          ...state.updatedVerifyOtp,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(verifyUpdatedOtp.rejected, (state, action) => {
        state.updatedVerifyOtp = {
          ...state.updatedVerifyOtp,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(verifyOtp.pending, (state, action) => {
        state.verifyOtpService = {
          ...state.verifyOtpService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.verifyOtpService = {
          ...state.verifyOtpService,
          status: "succeeded",
          // data: action.payload,
          error: null,
        };
        state.user = {
          data: { ...action.payload },
        };
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.verifyOtpService = {
          ...state.verifyOtpService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })

      .addCase(resendOtp.pending, (state, action) => {
        state.resendOtp = {
          ...state.resendOtp,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.resendOtp = {
          ...state.resendOtp,
          status: "succeeded",
          error: action.payload,
          data: null,
        };
      })
      .addCase(resendOtp.rejected, (state, action) => {
        state.resendOtp = {
          ...state.resendOtp,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(userResetPassword.pending, (state, action) => {
        state.resetPassword = { ...state.resetPassword, status: "loading" };
      })
      .addCase(userResetPassword.fulfilled, (state, action) => {
        state.resetPassword = {
          ...state.resetPassword,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userResetPassword.rejected, (state, action) => {
        state.resetPassword = {
          ...state.resetPassword,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })

      .addCase(updateResendOtp.pending, (state, action) => {
        state.updateResendOtpService = {
          ...state.updateResendOtpService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(updateResendOtp.fulfilled, (state, action) => {
        state.updateResendOtpService = {
          ...state.updateResendOtpService,
          status: "succeeded",
          error: null,
          data: action.payload,
        };
      })
      .addCase(updateResendOtp.rejected, (state, action) => {
        state.updateResendOtpService = {
          ...state.updateResendOtpService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })

      .addCase(userReauthenticate.pending, (state, action) => {
        state.reuathenticateService = {
          ...state.reuathenticateService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(userReauthenticate.fulfilled, (state, action) => {
        state.reuathenticateService = {
          ...state.reuathenticateService,
          status: "succeeded",
          error: null,
          data: action.payload,
        };
      })
      .addCase(userReauthenticate.rejected, (state, action) => {
        state.reuathenticateService = {
          ...state.reuathenticateService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      })
      .addCase(registerPassKey.fulfilled, (state, action) => {
        state.registerPassKey = {
          ...state.registerPassKey,
          registrationComplete: action.payload.registrationComplete,
          error: action.payload?.error || false,
        };
      })
      .addCase(registerPassKey.rejected, (state, action) => {
        state.registerPassKey = {
          ...state.registerPassKey,
          registrationComplete: action.payload.registrationComplete,
          error: action.payload?.error || false,
        };
      })
      .addCase(initiatePasskeylogin.fulfilled, (state, action) => {
        state.userLogin = {
          ...state.userLogin,
          status: "succeeded",
          data: action.payload,
          error: false,
        };
        state.user = {
          data: { ...action.payload },
        };
      })
      .addCase(initiatePasskeylogin.rejected, (state, action) => {
        state.userLogin = {
          ...state.userLogin,
          status: "failed",
          error: action.payload?.error,
          data: null,
        };
      })
      .addCase(fetchRegisteredPassKeys.fulfilled, (state, action) => {
        state.registeredPassKeys = {
          passKeys: action.payload,
          success: true,
        };
      })
      .addCase(fetchRegisteredPassKeys.rejected, (state, action) => {
        state.registeredPassKeys = {
          passKeys: action.payload,
          success: false,
        };
      })
      .addCase(clearPreviousErrors.fulfilled, (state, action) => {
        state.registerPassKey = {
          ...state.registerPassKey,
          registrationComplete: false,
          error: "",
        };
      })
      // Handle fetchUserDetails from remittanceSlice
      .addCase("remittance/fetchUserDetails/fulfilled", (state, action) => {
        // Save data to updateProfileService slice
        state.updateProfileService = {
          ...state.updateProfileService,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
        // Also update user state
        state.user = {
          ...state.user,
          data: { ...action.payload },
        };
      })
      .addCase("remittance/fetchUserDetails/rejected", (state, action) => {
        state.updateProfileService = {
          ...state.updateProfileService,
          status: "failed",
          error: action.payload,
          data: null,
        };
      });
  },
});

export const {
  otpValidateReset,
  resetPasswordReset,
  setUserType,
  setUserPhone,
  setMessagePopup,
  resetMigratedUser,
  resetVerifyOtp,
  resetResendOtp,
  reauthenticateUser,
  resetUserSignup,
} = authSlice.actions;

export default authSlice.reducer;
